<script>
  
	import { Router, Link, Route } from "svelte-routing";
  import Navbar from "./navbar.svelte";
</script>

<Navbar/>
<main class="container pt-5">
  <div class="bg-light p-5 rounded">
    <h1>Welcome</h1>
    <p class="text-secondary">
      This Site is Powered by the API of <b>Iptv-org.github.io</b>
      <br>
      Over 11000+ Free Channels
    </p>
    <Link
      class="btn btn-lg btn-primary"
      to="/Watch"
      role="button">See Available Channels</Link>
    <hr>
    <small>Site Developed By <a href="https://github.com/dev-itsarun">Arun Kumar</a></small>
  </div>
</main>
